//@ts-check
import React from "react";
import useAuth from "src/hooks/useAuth";

const PermissionGuard = ({ children, permissionAllow }) => {
  const { user } = useAuth();
  const canView = permissionAllow
    ? permissionAllow.includes(user?.accountType)
    : true;
  if (canView) return children;
  return null;
};

export default PermissionGuard;
